import { motion } from "framer-motion";

const SECTORS = ["Residential", "Commercial & Offices", "Hospitality", "Healthcare", "Infrastructure", "Industrial", "Interiors & Retail"];
const STACK = ["Revit", "Navisworks", "AutoCAD", "Dynamo", "Rhino + Grasshopper", "Tekla", "Civil 3D", "BIM 360 / ACC", "Lumion", "Enscape", "Twinmotion", "Staad Pro"];

export default function SectorsTech() {
  return (
    <section className="py-28 lg:py-36 border-b border-white/10" data-testid="sectors-tech-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16">
        <div>
          <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 mb-4">
            05 / Sectors
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="font-heading font-bold uppercase tracking-tighter text-2xl sm:text-3xl mb-10">
            Where we build
          </motion.h2>
          <ul>
            {SECTORS.map((s, i) => (
              <motion.li
                key={s}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="group flex items-center gap-4 py-3.5 border-b border-white/10 last:border-b-0 text-neutral-300 hover:text-white transition-colors duration-300"
                data-testid={`sector-item-${i}`}
              >
                <span className="font-mono-tech text-[10px] text-neutral-600">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-light tracking-wide group-hover:translate-x-2 transition-transform duration-300">{s}</span>
              </motion.li>
            ))}
          </ul>
        </div>

        <div>
          <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }} className="font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 mb-4">
            06 / Stack
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }} className="font-heading font-bold uppercase tracking-tighter text-2xl sm:text-3xl mb-10">
            Software & technology
          </motion.h2>
          <div className="flex flex-wrap gap-2.5">
            {STACK.map((t, i) => (
              <motion.span
                key={t}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                className="border border-white/15 px-4 py-2 font-mono-tech text-[11px] tracking-[0.15em] uppercase text-neutral-400 hover:border-white hover:text-white transition-colors duration-300 cursor-default"
                data-testid={`stack-chip-${i}`}
              >
                {t}
              </motion.span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
